import { clearToastTimer } from '#pplx/frontend/aether/toasts/utils/clearToastTimer.js';
export const scheduleToastTimer = (toast, onTimeout) => {
    const clearedToast = clearToastTimer(toast);
    if (toast.timeoutSeconds == null || toast.timeoutSeconds <= 0) {
        return clearedToast;
    }
    const timeoutMs = toast.timeoutSeconds * 1000;
    return {
        ...clearedToast,
        timer: setTimeout(onTimeout, timeoutMs),
        expiresAt: Date.now() + timeoutMs,
    };
};
//# sourceMappingURL=scheduleToastTimer.js.map